import React, { useState } from "react";
import CouponIcon from "../../assets/svg/CouponIcon";
import useGraffiti from "../../hooks/useGraffiti";
import useCoupon from "../../hooks/useCoupon";
import useWallet from "../../hooks/useWallet";
import WalletCouponSheet from "../utils/WalletCouponSheet";

const CouponCode = ({ container }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const { couponData, setCouponData } = useCoupon();
  const { triggerGraffiti } = useGraffiti();
  const { useWalletCredit, setUseWalletCredit } = useWallet();
  const [pendingCoupon, setPendingCoupon] = useState(null);

  // HAYD RULE: a coupon and the HAYD wallet cannot be used together. Applying a coupon while the wallet is on asks
  // first, then turns the wallet off.
  const applyCoupon = (coupon) => {
    if (useWalletCredit) setUseWalletCredit(false);
    setCouponData((prev) => ({
      ...prev,
      applied: true,
      appliedCoupon: coupon,
      suppressed: false,
    }));
    triggerGraffiti();
    setError("");
    setCode("");
    setPendingCoupon(null);
  };

  const handleApply = () => {
    if (!code?.trim()) return;

    const formattedCode = code?.trim().toLowerCase();

    const foundCoupon = couponData?.coupons?.find(
      (coupon) => coupon?.coupon_name?.toLowerCase() === formattedCode
    );

    if (!foundCoupon) {
      setError("Invalid coupon code");
      return;
    }

    if (
      couponData?.appliedCoupon?.coupon_name?.toLowerCase() === formattedCode
    ) {
      setError("This coupon is already applied");
      return;
    }

    if (useWalletCredit) {
      setPendingCoupon(foundCoupon);
      return;
    }
    applyCoupon(foundCoupon);
  };

  const removeAddedCoupon = () => {
    const bestCoupon = couponData?.bestCoupon;

    if (bestCoupon) {
      setCouponData((prev) => ({
        ...prev,
        appliedCoupon: bestCoupon,
      }));
      // triggerGraffiti();
    } else {
      setCouponData((prev) => ({
        ...prev,
        applied: false,
        appliedCoupon: null,
      }));
    }
  };

  const isBestCouponApplied =
    couponData?.appliedCoupon?.coupon_name?.toLowerCase() ===
    couponData?.bestCoupon?.coupon_name?.toLowerCase();
  // No coupon on the order (for example the wallet is in use): show the box to enter one.
  const showInput = !couponData?.applied || !couponData?.appliedCoupon || isBestCouponApplied;

  return (
    <div className="bg-white rounded-lg p-4 hayd-checkout-coupon-code-inner">
      {showInput ? (
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-3 flex-1 border border-blue-300 rounded-md px-3 py-2 focus-within:ring-1 focus-within:ring-blue-400">
            <CouponIcon width={24} height={24} className="fill-green-700" />
            <input
              type="text"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                setError("");
              }}
              placeholder="Enter coupon code"
              className="flex-1 outline-none text-black placeholder-gray-300 bg-transparent general-sans-regular text-[16px] tracking-wide w-[100%] max-w-[100%]"
            />
          </div>

          <button
            className={` text-blue-600 supreme-medium tracking-wide text-[16px] ${
              code.trim() ? "text-blue-600" : "text-gray-400 cursor-not-allowed"
            } `}
            onClick={handleApply}
            disabled={!code.trim()}
          >
            Apply
          </button>
        </div>
      ) : (
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-2 flex-wrap">
            <CouponIcon width={20} height={20} className="fill-green-700" />
            <p className="text-[16px] general-sans-medium">
              {couponData?.appliedCoupon?.coupon_name}
            </p>
            <div className="flex items-center gap-1 bg-[#3c9726] px-2 py-1 rounded-md">
              <p className="text-[12px] general-sans-regular text-white">
                Saved
              </p>
              <p className="text-[12px] supreme-bold text-white">
                ₹{(couponData?.appliedCoupon?.discountAmount).toFixed(0)}
              </p>
            </div>
          </div>

          <button
            className={` text-blue-600 supreme-medium tracking-wide text-[16px]`}
            onClick={removeAddedCoupon}
          >
            Remove
          </button>
        </div>
      )}

      {error && (
        <p className="text-red-500 text-[12px] mt-2 general-sans-medium">
          {error}
        </p>
      )}

      <WalletCouponSheet
        open={Boolean(pendingCoupon)}
        container={container}
        title="Coupons cannot be used with your HAYD wallet"
        message={`Apply ${pendingCoupon?.coupon_name || "this coupon"} instead? Your wallet will not be used for this order.`}
        confirmLabel="Apply coupon"
        cancelLabel="Keep wallet"
        onConfirm={() => applyCoupon(pendingCoupon)}
        onCancel={() => setPendingCoupon(null)}
      />
    </div>
  );
};

export default CouponCode;
